<mat-form-field *ngIf="!disabled">
  <mat-label>{{placeholder}}</mat-label>
  <input matInput [formControl]="ChildControl" [matAutocomplete]="autoAccounts"
         [required]="required">
  <mat-autocomplete #autoAccounts="matAutocomplete" [displayWith]="displayFn">
    <mat-option *ngFor="let res of Results" [value]="res">
      {{res.Email}}
      <span *ngIf="distanceTo && res.Address && res.Address.LatLng"> ({{res.Address.distanceTo(distanceTo)}} km)</span>
    </mat-option>
  </mat-autocomplete>
  <span matSuffix *ngIf="matSuffix">
        <ng-container *ngTemplateOutlet="matSuffix"></ng-container>
    </span>
  <mat-hint *ngIf="Selected">{{[Selected.FirstName, Selected.LastName].join(' ')}}</mat-hint>
</mat-form-field>

<mat-form-field *ngIf="disabled">
  <mat-label>{{placeholder}}</mat-label>
  <input [disabled]="true" [required]="required" [value]="Selected?.Email" matInput>
</mat-form-field>
